import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import StockAgeRuleModel from '../entities/back-store-age-rule'

interface StockAgeRuleState extends ListState<StockAgeRuleModel> {

}

class StockAgeRuleMutations extends ListMutations<StockAgeRuleModel>{

}
class BackStockAgeRule extends ListModule<StockAgeRuleState, any, StockAgeRuleModel>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StockAgeRuleModel>(),
        loading: false,
        editData: null,
    }
    actions = {
        async getAll(context: ActionContext<StockAgeRuleState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/StockAgeRule/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<StockAgeRuleModel>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async get(state: any, payload: any) {
            let reponse = await Ajax.get('/api/services/app/StockAgeRule/Get', { params: payload.data });
            return reponse.data.result;
        },
        async delete(state: any, payload: any) {
            let reponse = await Ajax.get('/api/services/app/StockAgeRule/Delete', { params: payload.data });
            return reponse.data.result;
        },
        async initial(state: any, payload: any) {
            let reponse = await Ajax.get('/api/services/app/StockAgeRule/Initial', { params: payload.data });
            return reponse.data.result;
        },
        async edit(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/StockAgeRule/edit', payload.data);
        },
    };
    mutations = {
        setCurrentPage(state: StockAgeRuleState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: StockAgeRuleState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const BackStockAgeRules = new BackStockAgeRule();
export default BackStockAgeRules;